import { FunctionComponent, useEffect, useState } from 'react'
import WorkroomPosts from './WorkroomPosts'
import WorkroomPost from './WorkroomPost'
import CreateNewWorkroomPost from './CreateNewWorkroomPost'
import { IWorkroomUserPermissions } from 'Frontend/scripts/models/workrooms.model'

interface WorkroomPostsOverviewProps {
  id: number
  permissions: IWorkroomUserPermissions | undefined
}

const WorkroomPostsOverview: FunctionComponent<WorkroomPostsOverviewProps> = ({ id, permissions }) => {
  const url = new URL(window.location.href)
  const [activeType, setActiveType] = useState<number>(
    url.searchParams.get('postType') ? Number(url.searchParams.get('postType')) : 0,
  )
  const [activePost, setActivePost] = useState<number>(
    url.searchParams.get('postId') ? Number(url.searchParams.get('postId')) : 0,
  )

  const typeOfPostComponent = () => {
    switch (activeType) {
      case 0:
        return (
          <WorkroomPosts
            id={id}
            permissionToCreatePost={permissions?.createPostInWorkroom}
            callback={(type, postId) => {
              url.searchParams.set('postType', type.toString())
              window.history.pushState({}, '', url)
              setActiveType(type)
              if (postId) {
                url.searchParams.set('postId', postId.toString())
                window.history.pushState({}, '', url)
                setActivePost(postId)
              }
            }}
          />
        )
      case 1:
        return (
          <WorkroomPost
            workroomId={id}
            postId={activePost}
            permissions={permissions}
            callback={(type) => {
              url.searchParams.set('postType', type.toString())
              url.searchParams.delete('postId')
              window.history.pushState({}, '', url)
              setActiveType(type)
            }}
          />
        )
      case 2:
        return (
          <CreateNewWorkroomPost
            id={id}
            callback={(type, postId) => {
              url.searchParams.set('postType', type.toString())
              window.history.pushState({}, '', url)
              setActiveType(type)
              if (postId) {
                setActivePost(postId)
                url.searchParams.set('postId', postId.toString())
                window.history.pushState({}, '', url)
              }
            }}
          />
        )
    }
  }

  return <>{typeOfPostComponent()}</>
}
export default WorkroomPostsOverview
